module.exports = __webpack_public_path__ + "static/media/member_downarrow.2461efe0.svg";